<div>
    <hub-modal-header headerText="{{ 'bikeshop.modal.update_job_card.job_card.link_another_job' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div class="linkable-jobs-container">
        <div class="linkable-jobs-title">{{ 'bikeshop.modal.update_job_card.job_card.link_jobcard_description'
            | translate }}</div>
        <div class="linkable-jobs-filters">
            <hub-checkbox class="filter-checkbox" [(ngModel)]="onlyThisCustomer" [label]="'Only for this customer'"
                (change)="onFilterChanged()"></hub-checkbox>
            <hub-input class="filter-search" [(ngModel)]="searchText" (ngModelChange)="onFilterChanged()"
                [icon]="'search'" [iconColor]="'#888888'" [allowClear]="true" [rounded]="true"
                [placeholder]="'Search by job number, customer or item'"></hub-input>
        </div>
        <div class="linkable-jobs-filter-info"> 
          <div>{{linkedCount}} {{'bikeshop.modal.update_job_card.tab.jobcard'| translate }}{{linkedCount == 1 ? '' : 's'}} {{ 'bikeshop.modal.add_edit_service_types.linked_technicians_form.linked' | translate }}</div>
            <div>{{ 'jobcard.linkedjobs.only.showing.valid' | translate }}</div>
        </div>

        <div class="linkable-jobs-header" *ngIf="filteredServices.length > 0">
            <div class="row">
              <div class="col-1 sortable" (click)="sortBy('jobCardID')"><span class="star-slot" *ngIf="showStars"></span>{{ 'bikeshop.dashboard.jobcard' | translate}} # <i [ngClass]="sortIcon('jobCardID')"></i></div>
                <div class="col-2 sortable" (click)="sortBy('scheduledDate')">{{ 'bikeshop.print.date' | translate }} <i [ngClass]="sortIcon('scheduledDate')"></i></div>
                <div class="col-2 sortable" (click)="sortBy('customer')">{{ 'bikeshop.modal.add_edit_user.cyclist' | translate }} <i [ngClass]="sortIcon('customer')"></i></div>
                <div class="col-2 sortable" (click)="sortBy('technician')">{{ 'bikeshop.modal.add_edit_user.technician' | translate }} <i [ngClass]="sortIcon('technician')"></i></div>
                <div class="col-2 sortable" (click)="sortBy('item')">{{ 'bikeshop.print.item' | translate }} <i [ngClass]="sortIcon('item')"></i></div>
                <div class="col-2 sortable" (click)="sortBy('status')">{{ 'general.headers.status' | translate }} <i [ngClass]="sortIcon('status')"></i></div>
                <div class="col-1 sortable right" (click)="sortBy('invoiceTotal')">{{ 'bikeshop.print.total' | translate }} <i [ngClass]="sortIcon('invoiceTotal')"></i></div>
            </div>
        </div>

        <div class="no-linkable-jobs" *ngIf="filteredServices.length === 0">
          {{ 'bikeshop.modal.update_job_card.job_card.no_open_jobcards_found' | translate }}
        </div>

        <div *ngFor="let service of pagedServices" class="linkable-job"
            (click)="linkSelectedService(service)" [ngClass]="{'selected': service.selected, 'disabled': isLinkLocked(service)}">
            <div class="row">
                <div class="col-1">
                    <span class="star-slot" *ngIf="showStars">
                        <i *ngIf="service.selected" class="fa" [ngClass]="isFavourite(service) ? 'fa-star' : 'fa-star-o'"></i>
                    </span>#{{service.jobCardID}}
                </div>
                <div class="col-2">{{service.scheduledDate | date: countryData.AngularDateFormat}}</div>
                <div class="col-2">{{service.customer}}</div>
                <div class="col-2">#{{service.technician}}</div>
                <div class="col-2">{{service.manufacturer}} {{service.model}}</div>
                <div class="col-2">{{getStatusLabel(service)}}</div>
                <div class="col-1 right">{{currencySymbol}}{{service.invoiceTotal.toFixed(2)}}</div>
            </div>
        </div>

        <p-paginator *ngIf="filteredServices.length > pageSize" [rows]="pageSize" [first]="first"
            [totalRecords]="filteredServices.length" (onPageChange)="onPageChange($event)"></p-paginator>

    </div>
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'onboarding.button.done' | translate" (buttonClick)="done()"
            [style]="'secondary'"
            [size]="'xl'"></hub-button>
    </div>
</div>
<p-toast key="linked-services-toast" position="bottom-center"></p-toast>
